import React, {Component} from 'react';
import {faUserPlus} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class ThanksPage extends Component {

  componentDidMount() {
    setTimeout(() => {
      window.location.href = "/kingstonhome"
    }, 10000)
  }

  render() {
    if (window.location.href.includes('invite')) {

      return (
        <div className="col-lg-12 text-center">
          <h1 className="my-5"> Thank you for submitting your nomination to <strong>Kingston<span style={{color: '#007D99'}}>Connect</span></strong></h1>
          <h5 className="my-5">Your nominee will receive instructions via email to add themselves to the talent pool. </h5>
          <FontAwesomeIcon
            icon={faUserPlus}
            size='8x'
          />
          <h5 className="my-5"> You will be redirected back to <strong>Kingston<span style={{color: '#007D99'}}>Connect</span></strong> homepage after 10 seconds</h5>
        </div>
      )
    } else if (window.location.href.includes('register')) {
      return (
        <div className="col-lg-12 text-center">
          <h1 className="my-5">
          Thank you for submitting a request to access the <strong>Kingston<span style={{color: '#007D99'}}>Connect</span></strong> talent pool through our HR Professionals Program
          </h1>
          <h5 className="my-5">
            Your submission has been received, and will be reviewed by our team within the next three business days.
            If you have any questions about this process, please don’t hesitate to reach out to us at talent.connect@cityofkingston.ca.
          </h5>
          <FontAwesomeIcon
            icon={faUserPlus}
            size='8x'
          />
          <h5 className="my-5"> You will be redirected back to <strong><span style={{color: 'rgb(38, 153, 232)'}}>Talent</span>Connect</strong> homepage after 10 seconds</h5>
        </div>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/ThanksPage.js